/* eslint-disable max-lines */
import { css } from 'linaria';
import { PictureDesktopNames, PictureTransformations } from 'common/components';
import { STORAGE_CDN_NAME, STORAGE_CDN_PATH } from '../../storage-constants';
import i18n from '../../../../../i18n.config';

export type StorageGalleryStructure = {
  src: string;
  srcSmall: string;
  srcThumb: string;
  name: string;
  title: string;
  alt: string;
  className?: string;
  transformations?: PictureTransformations;
};

export const IMAGE_PER_PAGE = 10;
export const INITIAL_IMAGE_PER_PAGE = 8;

export const BIG_IMAGE_TRANSFORMATIONS: PictureTransformations = {
  [PictureDesktopNames.ImgLargeDesk]: {
    width: 578,
    height: 784,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgDesk]: {
    width: 458,
    height: 784,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgTablet]: {
    width: 660,
    height: 456,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgMobile]: {
    width: 288,
    height: 216,
    objectFit: 'fill',
    dpr: '2.0',
  },
};

export const NONSTANDART_BIG_IMAGE_TRANSFORMATIONS: PictureTransformations = {
  [PictureDesktopNames.ImgLargeDesk]: {
    width: 578,
    height: 656,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgDesk]: {
    width: 458,
    height: 648,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgTablet]: {
    width: 660,
    height: 352,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgMobile]: {
    width: 288,
    height: 376,
    objectFit: 'fill',
    dpr: '2.0',
  },
};

export const getStorageGalleryList = (): (StorageGalleryStructure | null)[] => [
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/056.jpg/056.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/056.jpg/056.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/056.jpg/056.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '056.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/057.jpg/057.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/057.jpg/057.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/057.jpg/057.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '057.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/058.jpg/058.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/058.jpg/058.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/058.jpg/058.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '058.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/059.jpg/059.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/059.jpg/059.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/059.jpg/059.jpg`,
    title: 'Модульная система шкафов «Лион + Spaceo KUB»',
    alt: 'Лион + Spaceo KUB',
    name: '059.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/060.jpg/060.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/060.jpg/060.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/060.jpg/060.jpg`,
    title: 'Модульная система шкафов «Spaceo KUB»',
    alt: 'Spaceo KUB',
    name: '060.jpg',
    transformations: NONSTANDART_BIG_IMAGE_TRANSFORMATIONS,
  },
  null,

  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/4.jpg/4.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/04.jpg/04.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/4.jpg/4.jpg`,
    title: 'Модульная система шкафов «Лион + Spaceo KUB»',
    alt: 'Лион + Spaceo KUB',
    name: '04.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/49.jpg/49.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/049.jpg/049.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/49.jpg/49.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '049.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/51.jpg/51.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/051.jpg/051.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/51.jpg/51.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '051.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/52.jpg/52.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/052.jpg/052.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/52.jpg/52.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '052.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/5.jpg/5.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/05.jpg/05.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/5.jpg/5.jpg`,
    title: 'Вешалка настенная «Otto»',
    alt: 'Otto',
    name: '05.jpg',
    transformations: BIG_IMAGE_TRANSFORMATIONS,
    className: css`
      && {
        grid-row: 6 /8;
        height: 784px;

        @media (--only-tablet) {
          height: 456px;
        }

        @media (--only-mobile) {
          grid-row: 9 / 11;
          height: 372px;
        }
      }
    `,
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/41.jpg/41.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/041.jpg/041.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/41.jpg/41.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '041.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/42.jpg/42.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/042.jpg/042.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/42.jpg/42.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '042.jpg',
  },
  // 2
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/43.jpg/43.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/043.jpg/043.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/43.jpg/43.jpg`,
    title: 'Полка настенная «Spaceo»',
    alt: 'Spaceo',
    name: '043.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/44.jpg/44.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/044.jpg/044.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/44.jpg/44.jpg`,
    title: 'Модульная система шкафов «Spaceo KUB»',
    alt: 'Spaceo KUB',
    name: '044.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/45.jpg/45.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/045.jpg/045.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/45.jpg/45.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '045.jpg',
    transformations: BIG_IMAGE_TRANSFORMATIONS,
    className: css`
      && {
        grid-row: 9 / 11;
        height: 784px;

        @media (--from-tablet) {
          grid-column-start: 2;
        }

        @media (--only-tablet) {
          height: 456px;
        }

        @media (--only-mobile) {
          grid-row: 16 / 18;
          height: 372px;
        }
      }
    `,
  },
  // 3
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/46.jpg/46.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/046.jpg/046.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/46.jpg/46.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '046.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/47.jpg/47.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/047.jpg/047.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/47.jpg/47.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '047.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/13.jpg/13.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/013.jpg/013.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/13.jpg/13.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '013.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/14.jpg/14.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/014.jpg/014.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/14.jpg/14.jpg`,
    title: 'Металлическая гардеробная система',
    alt: i18n.t('gallery-section.metal-alt'),
    name: '014.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/15.jpg/15.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/015.jpg/015.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/15.jpg/15.jpg`,
    title: 'Двери-купе',
    alt: i18n.t('gallery-section.sliding-doors-name'),
    name: '015.jpg',
    transformations: BIG_IMAGE_TRANSFORMATIONS,
    className: css`
      && {
        grid-row: 12 / 14;
        height: 784px;

        @media (--only-tablet) {
          height: 456px;
        }

        @media (--only-mobile) {
          grid-row: 21 / 23;
          height: 372px;
        }
      }
    `,
  },
  // 4
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/16.jpg/16.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/016.jpg/016.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/16.jpg/16.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '016.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/17.jpg/17.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/017.jpg/017.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/17.jpg/17.jpg`,
    title: 'Металлическая гардеробная система',
    alt: i18n.t('gallery-section.metal-alt'),
    name: '017.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/18.jpg/18.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/018.jpg/018.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/18.jpg/18.jpg`,
    title: 'Многофункциональная система хранения KUB',
    alt: 'Spaceo KUB',
    name: '018.jpg',
    transformations: BIG_IMAGE_TRANSFORMATIONS,
    className: css`
      && {
        grid-row: 15 / 17;
        height: 784px;

        @media (--from-tablet) {
          grid-column-start: 2;
        }

        @media (--only-tablet) {
          height: 456px;
        }

        @media (--only-mobile) {
          grid-row: 28 / 30;
          height: 372px;
        }
      }
    `,
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery/019.jpg/019-3.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/019.jpg/019-3.jpg`,
    srcThumb: '',
    title: 'Металлическая гардеробная система',
    alt: i18n.t('gallery-section.metal-alt'),
    name: '019.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/20.jpg/20.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/020.jpg/020.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/20.jpg/20.jpg`,
    title: 'Двери-купе',
    alt: i18n.t('gallery-section.sliding-doors-name'),
    name: '020.jpg',
  },
  // 5
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/21.jpg/21.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/021.jpg/021.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/21.jpg/21.jpg`,
    title: 'Модульная система шкафов «Лион + обувница»',
    alt: 'Лион + обувница',
    name: '021.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery/022.jpg/022-3.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/022.jpg/022-3.jpg`,
    srcThumb: '',
    title: 'Металлическая гардеробная система',
    alt: i18n.t('gallery-section.metal-alt'),
    name: '022.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/23.jpg/23.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/023.jpg/023.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/23.jpg/23.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '023.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/24.jpg/24.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/024.jpg/024.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/24.jpg/24.jpg`,
    title: 'Металлическая гардеробная система',
    alt: i18n.t('gallery-section.metal-alt'),
    name: '024.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/25.jpg/25.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/025.jpg/025.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/25.jpg/25.jpg`,
    title: 'Многофункциональная система хранения KUB',
    alt: 'Spaceo KUB',
    name: '025.jpg',
    transformations: BIG_IMAGE_TRANSFORMATIONS,
    className: css`
      && {
        grid-row: 18 / 20;
        height: 784px;

        @media (--only-tablet) {
          height: 456px;
        }

        @media (--only-mobile) {
          grid-row: 33 / 35;
          height: 372px;
        }
      }
    `,
  },
  // 6
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/26.jpg/26.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/026.jpg/026.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/26.jpg/26.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '026.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/27.jpg/27.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/027.jpg/027.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/27.jpg/27.jpg`,
    title: 'Металлическая гардеробная система',
    alt: i18n.t('gallery-section.metal-alt'),
    name: '027.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/28.jpg/28.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/028.jpg/028.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/28.jpg/28.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '028.jpg',
    transformations: BIG_IMAGE_TRANSFORMATIONS,
    className: css`
      && {
        grid-row: 21 / 23;
        height: 784px;

        @media (--from-tablet) {
          grid-column-start: 2;
        }

        @media (--only-tablet) {
          height: 456px;
        }

        @media (--only-mobile) {
          grid-row: 40 / 42;
          height: 372px;
        }
      }
    `,
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/29.jpg/29.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/029.jpg/029.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/29.jpg/29.jpg`,
    title: 'Металлическая гардеробная система',
    alt: i18n.t('gallery-section.metal-alt'),
    name: '029.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/30.jpg/30.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/030.jpg/030.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/30.jpg/30.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '030.jpg',
  },
  // 7
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/31.jpg/31.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/031.jpg/031.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/31.jpg/31.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '031.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/32.jpg/32.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/032.jpg/032.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/32.jpg/32.jpg`,
    title: 'Металлическая гардеробная система',
    alt: i18n.t('gallery-section.metal-alt'),
    name: '032.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/33.jpg/33.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/033.jpg/033.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/33.jpg/33.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '033.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/34.jpg/34.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/034.jpg/034.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/34.jpg/34.jpg`,
    title: 'Металлическая гардеробная система',
    alt: i18n.t('gallery-section.metal-alt'),
    name: '034.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/35.jpg/35.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/035.jpg/035.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/35.jpg/35.jpg`,
    title: 'Многофункциональная система хранения KUB',
    alt: 'Spaceo KUB',
    name: '035.jpg',
    transformations: BIG_IMAGE_TRANSFORMATIONS,
    className: css`
      && {
        grid-row: 24 / 26;
        height: 784px;

        @media (--only-tablet) {
          height: 456px;
        }

        @media (--only-mobile) {
          grid-row: 45 / 47;
          height: 372px;
        }
      }
    `,
  },
  // 8
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/36.jpg/36.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/036.jpg/036.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/36.jpg/36.jpg`,
    title: 'Металлическая гардеробная система',
    alt: i18n.t('gallery-section.metal-alt'),
    name: '036.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/37.jpg/37.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/037.jpg/037.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/37.jpg/37.jpg`,
    title: 'Двери-купе',
    alt: i18n.t('gallery-section.sliding-doors-name'),
    name: '037.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/38.jpg/38.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/038.jpg/038.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/38.jpg/38.jpg`,
    title: 'Многофункциональная система хранения KUB',
    alt: 'Spaceo KUB',
    name: '038.jpg',
    transformations: BIG_IMAGE_TRANSFORMATIONS,
    className: css`
      && {
        grid-row: 27 / 29;
        height: 784px;

        @media (--from-tablet) {
          grid-column-start: 2;
        }

        @media (--only-tablet) {
          height: 456px;
        }

        @media (--only-mobile) {
          grid-row: 53 / 55;
          height: 372px;
        }
      }
    `,
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/39.jpg/39.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/039.jpg/039.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/39.jpg/39.jpg`,
    title: 'Металлическая гардеробная система',
    alt: i18n.t('gallery-section.metal-alt'),
    name: '039.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/40.jpg/40.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/040.jpg/040.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/40.jpg/40.jpg`,
    title: 'Двери-купе',
    alt: i18n.t('gallery-section.sliding-doors-name'),
    name: '040.jpg',
  },
  // 9
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/6.jpg/6.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/06.jpg/06.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/6.jpg/6.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '06.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/7.jpg/7.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/07.jpg/07.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/7.jpg/7.jpg`,
    title: 'Металлическая гардеробная система',
    alt: i18n.t('gallery-section.metal-alt'),
    name: '07.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/8.jpg/8.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/08.jpg/08.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/8.jpg/8.jpg`,
    title: 'Металлическая гардеробная система',
    alt: i18n.t('gallery-section.metal-alt'),
    name: '08.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/9.jpg/9.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/09.jpg/09.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/9.jpg/9.jpg`,
    title: 'Металлическая гардеробная система',
    alt: i18n.t('gallery-section.metal-alt'),
    name: '09.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/10.jpg/10.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/010.jpg/010.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/10.jpg/10.jpg`,
    title: 'Двери-купе',
    alt: i18n.t('gallery-section.sliding-doors-name'),
    name: '010.jpg',
    transformations: BIG_IMAGE_TRANSFORMATIONS,
    className: css`
      && {
        grid-row: 30 / 32;
        height: 784px;

        @media (--only-tablet) {
          height: 456px;
        }

        @media (--only-mobile) {
          grid-row: 57 / 59;
          height: 372px;
        }
      }
    `,
  },
  // 10
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/11.jpg/11.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/011.jpg/011.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/11.jpg/11.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '011.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/12.jpg/12.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/012.jpg/012.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/12.jpg/12.jpg`,
    title: 'Металлическая гардеробная система',
    alt: i18n.t('gallery-section.metal-alt'),
    name: '012.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/48.jpg/48.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/048.jpg/048.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/48.jpg/48.jpg`,
    title: 'Обувница',
    alt: i18n.t('gallery-section_shoe-name'),
    name: '048.jpg',
    transformations: BIG_IMAGE_TRANSFORMATIONS,
    className: css`
      && {
        grid-row: 33 / 35;
        height: 784px;

        @media (--from-tablet) {
          grid-column-start: 2;
        }

        @media (--only-tablet) {
          height: 456px;
        }

        @media (--only-mobile) {
          grid-row: 65 / 67;
          height: 372px;
        }
      }
    `,
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/2.jpg/2.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/02.jpg/02.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/2.jpg/2.jpg`,
    title: 'Многофункциональная система хранения KUB',
    alt: 'Spaceo KUB',
    name: '02.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/50.jpg/50.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/050.jpg/050.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/50.jpg/50.jpg`,
    title: 'Обувница «Otto»',
    alt: 'Otto',
    name: '050.jpg',
  },
  // 11
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/3.jpg/3.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/03.jpg/03.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/3.jpg/3.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '03.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/1.jpg/1.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/01.jpg/01.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/1.jpg/1.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '01.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/53.jpg/53.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/053.jpg/053.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/53.jpg/53.jpg`,
    title: 'Многофункциональная система хранения KUB',
    alt: 'Spaceo KUB',
    name: '053.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/54.jpg/54.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/054.jpg/054.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/54.jpg/54.jpg`,
    title: 'Модульная система шкафов «Лион»',
    alt: 'Лион',
    name: '054.jpg',
  },
  {
    src: `${STORAGE_CDN_NAME}/gallery-popup/55.jpg/55.jpg`,
    srcSmall: `${STORAGE_CDN_NAME}/gallery/055.jpg/055.jpg`,
    srcThumb: `${STORAGE_CDN_PATH}/gallery-popup-thumb/55.jpg/55.jpg`,
    title: 'Металлическая гардеробная система',
    alt: i18n.t('gallery-section.metal-alt'),
    name: '055.jpg',
    transformations: BIG_IMAGE_TRANSFORMATIONS,
    className: css`
      && {
        grid-row: 36 / 38;
        height: 784px;

        @media (--only-tablet) {
          height: 456px;
        }

        @media (--only-mobile) {
          grid-row: 69 / 71;
          height: 372px;
        }
      }
    `,
  },
];
